'use strict'

export const modal = (() => {
    let _modals
    let _backdrop

    const moveToEnd = () => {
        _modals.forEach(modal => {
            document.body.appendChild(modal)
        })
    }

    const checkBackdrop = () => {
        if(!_backdrop) return

        if(Array.from(_modals).some(modal => modal.classList.contains('show'))) {
            const _scrollY = window.scrollY
            const _scrollBarWidth = window.innerWidth - document.documentElement.clientWidth

            // Show backdrop
            _backdrop.classList.add('show')

            // Add class to body
            document.body.classList.add('modal-open')
            // And the same to header
            document.querySelector('header').classList.add('modal-open')

            // Compensate vertical scroll
            document.body.style.top = -_scrollY + 'px'

            // Compensate scrollbar width
            if(document.dir == 'rtl') {
                document.body.style.paddingLeft = _scrollBarWidth + 'px'
            } else {
                document.body.style.paddingRight = _scrollBarWidth + 'px'
            }
        } else {
            const _scrollY = document.body.style.top

            // Hide backdrop
            _backdrop.classList.remove('show')

            // Remove class from body
            document.body.classList.remove('modal-open')
            // And the same from header
            document.querySelector('header').classList.remove('modal-open')

            // Remove style top and padding from body
            document.body.style.top = ''
            if(document.dir == 'rtl') {
                document.body.style.paddingRight = ''
            } else {
                document.body.style.paddingRight = ''
            }

            // Restore scroll top position
            window.scrollTo({
                top: -1 * parseInt(_scrollY),
                behavior: 'instant'
            })

        }
    }

    const clickButton = (event) => {
        const _button = event.target

        if (!_button) return
        
        const _popupId = _button.dataset.popup

        if (!_popupId) return
        
        const _popup = document.getElementById(_popupId)

        if(!_popup) return
        
        _popup.classList.add('show')
        _popup.setAttribute('aria-hidden', 'false')

        checkBackdrop()

        const popupImage = _button.dataset.popupImage

        if (popupImage) {
            const _popupImageContainer = _popup.querySelector('[data-popup-image]')

            if(_popupImageContainer) {
                _popupImageContainer.src = popupImage
            }
        }
    }

    const closePopup = (event) => {
        const _button = event.target

        if (!_button) return
        
        const _popupId = _button.dataset.popupClose

        let _popup = null

        if (_popupId) {
            _popup = document.getElementById(_popupId)
        } else {
            _popup = _button.closest('.modal')
        }

        if (_popup) {
            // Close the popup
            _popup.classList.remove('show')
            _popup.setAttribute('aria-hidden', 'true')
        } else {
            // Close all popups
            _modals.forEach(modal => {
                modal.classList.remove('show')
                modal.setAttribute('aria-hidden', 'true')
            })
        }

        checkBackdrop()
    }

    const initButtons = () => {
        const _buttons = document.querySelectorAll('[data-popup]')
        const _closeButtons = document.querySelectorAll('[data-popup-close]')

        _buttons.forEach(button => {
            button.addEventListener('click', clickButton)
        })

        _closeButtons.forEach(button => {
            button.addEventListener('click', closePopup)
        })

        if(!_backdrop) return

        _backdrop.addEventListener('click', () => {
            if(!_backdrop.classList.contains('show')) return

            const _openPopups = document.querySelectorAll('.modal.show')

            _openPopups.forEach(popup => {
                popup.classList.remove('show')
            })

            checkBackdrop()
        })
    }

    const init = () => {
        _modals = document.querySelectorAll('.modal')
        _backdrop = document.querySelector('.modal-backdrop')
    
        moveToEnd()
        initButtons()
    }

    return {
        init
    }
})()